module.exports = __webpack_public_path__ + "images/68a063daaed512384c3f968286998085.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/nothing_stops_detroit/detroit.jpg
// module id = 165
// module chunks = 24